import { QueryClient } from 'react-query'

// Create a query client with specific configuration for our app
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 1000 * 60 * 5, // 5 minutes default
    },
  },
})
